import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { FirebaseObjectObservable } from 'angularfire2/database';

import { DBService } from '../../db.service';

@Component({
  selector: 'show-newsletter',
  templateUrl: './show-newsletter.component.html',
  styleUrls: ['./show-newsletter.component.scss']
})
export class ShowNewsletterComponent implements OnInit {
  newsletterObservable: FirebaseObjectObservable<any>;
  newsletter: any;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dbService: DBService
  ) { }

  ngOnInit() {
    this.route.params.forEach((params: Params) => {
      this.newsletterObservable = this.dbService.getNewsletter(params['key']);
      this.newsletterObservable.subscribe(newsletter => {
        this.newsletter = newsletter;
      });
    });
  }

  onEditClicked() {
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onDeleteClicked() {
    this.showModalBg = true;
    this.showDeleteModal = true;
  }

  onConfirmDeletePost() {
    this.onHideDeleteModal()
    this.dbService.deleteNewsletter(this.newsletter.$key, this.newsletter.fileName);
    this.router.navigate([`/newsletters`]);
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/newsletter/show-newsletter/show-newsletter.component.ts